import { t, type I18nLocale } from '@ardoq/i18n';
import type {
  ImagePreviewErrorMessages,
  ImagePreviewLabels,
} from '@ardoq/image-preview';

export const getImagePreviewLabels = (
  i18nLocale: I18nLocale
): ImagePreviewLabels => ({
  zoomToLabel: t(i18nLocale, 'imagePreview:zoomTo', 'Zoom to'),
  zoomInLabel: t(i18nLocale, 'imagePreview:zoomIn', 'Zoom in'),
  zoomOutLabel: t(i18nLocale, 'imagePreview:zoomOut', 'Zoom out'),
  resetZoomLabel: t(
    i18nLocale,
    'imagePreview:resetZoom',
    'Reset zoom and position'
  ),
  clearBackgroundTooltip: t(
    i18nLocale,
    'imagePreview:clearBackground',
    'Clear background color'
  ),
  darkBackgroundTooltip: t(
    i18nLocale,
    'imagePreview:darkBackground',
    'Set dark background color'
  ),
});

export const getImagePreviewErrorMessages = (
  i18nLocale: I18nLocale
): ImagePreviewErrorMessages => ({
  errorTitle: t(
    i18nLocale,
    'imagePreview:errorTitle',
    'Failed to preview image'
  ),
  fetchFailedMessage: t(
    i18nLocale,
    'imagePreview:fetchFailedMessage',
    'Failed to fetch image'
  ),
});

type ImagePreviewModalChrome = {
  closeButtonText: string;
  downloadLinkLabel: string;
};

export const getImagePreviewModalChrome = (
  i18nLocale: I18nLocale
): ImagePreviewModalChrome => ({
  closeButtonText: t(i18nLocale, 'imagePreview:closeButton', 'Close'),
  downloadLinkLabel: t(i18nLocale, 'imagePreview:downloadLink', 'Download'),
});
